import React from 'react'

export function CVMakerPage() {
    return (
        <div>CVMakerPage!</div>
    )
}